import { LocaleSwitcher as SharedLocaleSwitcher } from '@packages/locale-switcher';
import { TFunction } from 'i18next';
import { useRouter } from 'next/router';

export type LocaleSwitcherProps = {
  locales?: Array<{ locale: string; labels: { nb: string; en: string } }>;
  translation: TFunction;
};

export default function LocaleSwitcher({
  locales = [],
  translation,
}: LocaleSwitcherProps) {
  const router = useRouter();

  return (
    <SharedLocaleSwitcher
      menuOffset={40}
      locales={locales.map(({ locale, labels }) => ({
        value: locale,
        label: router.locale === 'nb' ? labels.nb : labels.en,
      }))}
      currentLocale={router.locale ?? 'nb'}
      label={translation('navigation.switch_language')}
      onLocaleChange={(locale) => {
        void router.push(router.asPath, router.asPath, { locale });
      }}
    />
  );
}
